import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import appConfig from '../../../config.js';
import Table from '../../commons/Table/Table';
import Modal from '../../commons/Modal/Modal';
import { InputField, ColorField, TextInputField } from '../../commons/Inputs';
import FloatingActionButton from '../../commons/Buttons/FloatingActionButton';

import {
    getProceduresApi
} from '../../actions/procedures';

let $ = window.jQuery;
let Handlebars = window.Handlebars;
let Bloodhound = window.Bloodhound;

class Procedures extends Component {

    static propTypes = {
        getProceduresApi: PropTypes.func.isRequired,
        session: PropTypes.object.isRequired
    };

    state = {
        data : [],
        headers : [
            {key : 'category', label : 'Category'},
            {key : 'procedure', label : 'Procedure'},
            {key : 'abbreviation', label : 'Abbreviation'},
            {key : 'price', label : 'Price'},
            {key : 'color', label : 'Color'},
            {key : 'actions', label : 'Actions'},
            {key : 'id', label: 'id'}
        ],
        isSavingProcedure : false,
        isEditingProcedure: false,
        id: '',
        category: '',
        procedure: '',
        abbreviation: '',
        price: '',
        color: '#1133CC',
        categories : [],
        errors: []
    };

    handleFABClick = () => {
        $('#procedureModal').modal('show');
    };

    generateTableActions = (id) => {
        return (
            <div className="">
                <button href="#"
                        className='btn btn-xs tooltips blue'
                        data-container="body"
                        data-placement="top"
                        data-original-title='Edit'
                        onClick={this.handleEditProcedure}
                        data-id={id}>
                    <i className='glyphicon glyphicon-edit'
                       data-id={id}/>
                </button>
                <button href="#"
                        className='btn btn-xs tooltips deletePopover red'
                        data-container="body"
                        data-placement="top"
                        data-original-title='Delete'
                        data-id={id}
                        data-toggle="confirmation"
                        data-singleton="true">
                    <i className='glyphicon glyphicon-remove'
                       data-id={id} />
                </button>
            </div>
        );
    };

    generateColorBox = (color) => {
        return (
            <div style={{backgroundColor: color}}>
                &nbsp;
            </div>
        )
    };

    getAllProcedures = () => {
        let url = appConfig.apiUrl + 'management/dental/procedures?q=';

        axios({
            url: url,
            timeout: 20000,
            method: 'get'
        }).then((res) => {
            let displayData = res.data.data;

            displayData.forEach((row) => {
                // generate color boxes
                row.colorText = row.color;
                row.color = this.generateColorBox(row.color);
                row.price = parseFloat(row.price).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');

                // add actions
                row.actions = this.generateTableActions(row.id);
            });

            this.setState({
                data : displayData
            }, (e) => {
                $('#table').dataTable({
                    "columnDefs": [
                        {
                            "targets": [6], //id
                            "visible": false,
                            "searchable": false
                        }
                    ],
                    "order": [[ 6, 'desc' ]]
                });
                $('.tooltips').tooltip();

                let self = this;

                $('.deletePopover').confirmation({
                    title: 'Are you sure to delete this Procedure?',
                    popout: true,
                    btnOkClass: 'btn btn-primary btn-sm',
                    btnCancelClass: 'btn btn-danger btn-sm',
                    container: 'body',
                    onConfirm: function() {
                        let procedureId = $(this).data('id');
                        self.deleteProcedure(procedureId);
                    }
                });
            });

            // Re-GET all procedures for reducers
            this.props.getProceduresApi();
        }).catch((res) => {
            // display error
        });
    };

    handleSaveProcedure = () => {
        // disable modal buttons
        this.setState({
            isSavingProcedure : true,
        });
        let url = appConfig.apiUrl + (this.state.isEditingProcedure ? 'management/dental/procedures/'+this.state.id : 'management/dental/procedures');
        let procedure = $('#procedureForm').serializeArray();
        if(this.state.isEditingProcedure === true) {
            procedure.push({name: '_method', value: 'PUT'});
        }

        axios({
            url: url,
            timeout: 20000,
            method: 'post',
            data: window.jQuery.param(procedure)
        }).then((res) => {

            // enable modal buttons again
            this.setState({
                isSavingProcedure : false
            }, (e) => {
                // destroy table
                $('#table').dataTable().fnDestroy();

                // refresh table
                this.getAllProcedures();
            });

            // clear form
            this.setState({
                isEditingProcedure: false,
            }, (e) => {

                // close modal
                $('#procedureModal').modal('toggle');
                this.clearForm();
            })
        }).catch((error) => {
            let fields = Object.keys(error.response.data.errors);

            let errors = this.state.errors;
            fields.forEach((item) => {
                errors[item] = true;
            });

            this.setState({
                errors,
                isSavingProcedure : false
            });
        });
    };

    handleEditProcedure = (e) => {
        let id = parseInt(e.target.dataset.id, 10);
        let index = this.state.data.findIndex((item) => item.id === id);
        let procedure = this.state.data[index];

        if(procedure) {
            this.setState({
                isEditingProcedure : true,
                id : procedure.id,
                category: procedure.category,
                procedure: procedure.procedure,
                abbreviation: procedure.abbreviation,
                price: procedure.price,
                color: procedure.colorText,
            }, (e) => {
                $('#color').minicolors('value', procedure.colorText);
                $('#procedureModal').modal('toggle');
            })
        }
    };

    deleteProcedure = (id) => {
        let url = appConfig.apiUrl + 'management/dental/procedures/'+id;

        axios({
            url: url,
            timeout: 20000,
            method: 'post',
            data: {'_method': 'DELETE'}
        }).then((res) => {

            // destroy table
            $('#table').dataTable().fnDestroy();

            // refresh table
            this.getAllProcedures();
        }).catch((res) => {
            // display error
        });
    };

    handleCloseModal = () => {
        this.clearForm();
    };

    clearForm = () => {
        $('#color').minicolors('value', '#1133CC');
        $('.form-group').removeClass('has-error');
        this.setState({
            isEditingProcedure: false,
            id: '',
            category: '',
            procedure: '',
            abbreviation: '',
            price: '',
            color: '#1133CC',
            errors: []
        });
    };

    componentDidMount() {
        this.getAllProcedures();

        $('#color').minicolors({
            animationSpeed: 50,
            control: 'wheel',
            defaultValue: '#1133CC',
            theme: 'bootstrap'
        });

        let self = this;
        $('#price').inputmask("numeric", {
            radixPoint: ".",
            groupSeparator: ",",
            digits: 2,
            autoGroup: true,
            // prefix: '₱ ',
            rightAlign: false,
            autoUnmask: true,
            max: 999999.99, //max val on api DECIMAL(8, 2)
            oncomplete: (e) => {
                self.setState({
                    price: e.target.value
                })
            }
        });

        $('.swatch').swatchify({
            colors: "#D10000,#FF6622,#FFDA21,#33DD00,#1133CC,#220066,#330044",
            click: function(e) {
                let selectedColor = $(e.target).attr('color');
                $('#color').minicolors('value', selectedColor);
            }
        });

        /*initialize typeahead*/
        $('#category').typeahead(null, {
            display : 'category',
            source: this.state.categories,
            templates: {
                empty: Handlebars.compile([
                    '<div class="empty-message" style="font-size: 13px; color: #000; padding: 10px;">',
                    'Unable to find any category that match the current search query',
                    '</div>'
                ].join('\n')),
                suggestion: Handlebars.compile([
                    '<div class="media">',
                    '<div class="media-body">',
                    '<h4 class="media-heading">{{category}}</h4>',
                    '</div>',
                    '</div>'
                ].join(''))
            }
        }).on('typeahead:selected', (obj, datum) => {
            let category = datum.category;
            this.setState({
                category
            })
        }).on('typeahead:active', (e) => {
            // $(e.target).siblings('.form-control-focus').remove();
            // $(e.target).siblings('.help-block').remove();
            // $(e.target).parent().append('<div class="form-control-focus"></div><span class="help-block">Category Search</span>');
        });
    }

    componentWillMount() {
        var categories = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: appConfig.apiUrl + 'management/dental/procedures/categories?q=%QUERY',
                wildcard: '%QUERY'
            }
        });

        this.setState({categories});
    }

    render() {
        let categoryCustomLabel = {
            top: 0,
            marginBottom: 0,
            fontSize: "14px",
            color: (this.state.errors.category) ? "#e73d4a" : "#888",
            width: "100%",
            position: "absolute",
            left: 0,
            bottom: 0,
            pointerEvents: "none"
        };

        return(
            <div className="page-content">

                <div className="row">
                    <div className="col-md-12">
                        <h3 className="page-title">
                            Management &nbsp; <small>Procedures</small>
                        </h3>
                    </div>
                </div>

                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div className="portlet light portlet-fit">
                        <div className="portlet-title">
                            <div className="caption">
                                <i className=" icon-list font-blue" />
                                <span className="caption-subject font-blue sbold uppercase">Procedures</span>
                            </div>
                        </div>
                        <div className="portlet-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <Table id={"table"} headers={this.state.headers} data={this.state.data} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <FloatingActionButton
                            title="Add Procedure"
                            onClick={this.handleFABClick} />
                    </div>
                </div>

                <Modal
                    id="procedureModal"
                    header="Add Procedure"
                    onNegativeClickEvent={this.handleCloseModal}
                    onPositiveClickEvent={this.handleSaveProcedure}
                    isSaving={this.state.isSavingProcedure}
                    width="0">

                    <div className="row">
                        <div className="col-md-12">
                            <form id="procedureForm">

                                <div className="row">
                                    <div className="col-md-4">
                                        <ColorField val={this.state.color} id="color" label="Selected color" help="Color of procedure" />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="form-group form-md-line-input form-md-floating-label">
                                            <div className="swatch" data-name="Select a color"></div>
                                            <div className="">Pick a predefined color</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-12">
                                        <InputField customLabelStyle={categoryCustomLabel}
                                                    val={this.state.category}
                                                    onChange={(e) => {this.setState({category: e.target.value})}}
                                                    id="category"
                                                    label="Category * "
                                                    help=""
                                                    type="text"
                                                    hasError={this.state.errors.category}/>

                                        <TextInputField id="procedure" label="Procedure *"
                                                        help=""
                                                        onChange={(e) => {this.setState({procedure: e.target.value})}}
                                                        val={this.state.procedure}
                                                        hasError={this.state.errors.procedure} />

                                        <TextInputField id="abbreviation" label="Abbreviation *"
                                                        help="Should be unique"
                                                        onChange={(e) => {this.setState({abbreviation: e.target.value})}}
                                                        val={this.state.abbreviation}
                                                        hasError={this.state.errors.abbreviation} />

                                        <TextInputField id="price" label="Price"
                                                        help=""
                                                        onChange={(e) => {this.setState({price: e.target.value})}}
                                                        val={this.state.price} />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        session: state.session
    }
};

export default connect(mapStateToProps, {
    getProceduresApi
})(Procedures);


/** WEBPACK FOOTER **
 ** ./src/containers/Procedures/index.js
 **/